import React, { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
// import Data from "./components/Utils/content.json" Uncomment to access local data
import Header from "./components/Header/index.js";
import { useParams} from 'react-router-dom';
import Banner from "./components/Banner/Banner";
import rootReducer from "./store/reducers";
import { legacy_createStore as createStore } from 'redux'
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import useSunWestSuccessYears from './components/Utils/useSunWestSuccessYears.js';
import useRefinancePageData from "./components/Utils/useRefinancePageData.js";
import Shimmer from "./components/ShimmerUI/ShimmerUI.js";
import MediaQuery from "react-responsive";
import useCommonJson from "./components/Utils/useCommonJson.js";

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const RefinanceCarousel = lazy(() => import("./components/RefinanceCarousel/RefinanceCarousel.js"));
const WhyRefinance = lazy(() => import("./components/WhyRefinance/WhyRefinance.js"));
const WhyChooseSunwest = lazy(() => import("./components/WhyChooseSunwest/WhyChooseSunwest.js"));
const LogoCarousel = lazy(() => import("./components/Logo Section/NewLogoSection.js"));
const Celebrity = lazy(() => import("./components/CelebritySection/Celebrity.js"));
const RealStories = lazy(() => import("./components/RealStories/RealStories.js"));
const Blog = lazy(() => import("./components/Blog/Blog.js"));
const Disclaimer = lazy(() => import("./components/Disclaimer/Disclaimer.js"));
const LoTemplate = lazy(() => import("./components/LoTemplate/LoTemplate.js"))
const Footer = lazy(() => import("./components/Footer/Footer.js"))


export default function Home() {

  const data = useRefinancePageData();
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const successYears = useSunWestSuccessYears();
  const { loName } = useParams();
  const loCommonData = useCommonJson(loName);

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);  // Scroll to top on page refresh
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  if (data === null ) {
    return <Shimmer />
  } else if (loName !== null && data === null){
    return <Shimmer />
  }

  const loadingStyle = {
    textAlign: 'center'
  };

  return (
    <>
      <Helmet>
        <title>{`Expert Refinancing Solutions with Sun West | ${successYears}+ Years of Excellence`}</title>
        <meta name="description" content={`Discover competitive refinance rates and expert guidance from Sun West. With  ${successYears}+ years of experience, fast closings, and exceptional service, we're your trusted partner in refinancing.`} />
        <meta
          name="keywords"
          content="Refinance, Mortgage Refinance, Lower Monthly Payments, Reduce Mortgage Term, Remove Private Mortgage Insurance, Get Cash-Out Refinance, Rate and Term Refinance, Streamline Refinance, FHA loan refinance, VA loan refinance, USDA loan refinance, Conventional loan refinance, Home Equity, Cash-Out Refinance, FHA Refinance, VA Refinance, Conventional Refinance, Jumbo Loans, Non-QM Refinance, Refinance Calculator, Sun West Mortgage, Loan Refinancing, Mortgage Rates, Today’s Refinance Rates, Save with Refinance, Calculate Refinance Savings, Pavan Agarwal, Customer Testimonials, Refinance Blogs, Best Lender for Refinance, Best Mortgage Lender for Refinance"
        />
        <link rel="canonical" href={window.location.href.endsWith('/') ? window.location.href : `${window.location.href}/`} />
      </Helmet>
      <Header fetchpriority="high" />
      <Provider store={store}>
        <Suspense fallback={<div />}>
          <Banner fetchpriority="high" data={data} loCommonData={loCommonData} />
        </Suspense>
      </Provider>
        <Suspense fallback={<div />}>
          <RefinanceCarousel data={data} />
        </Suspense>
      <MediaQuery minWidth={992}>
          <Suspense fallback={<div />}>
            <LogoCarousel />
          </Suspense>
          </MediaQuery>
      {showOtherComponents && (
        <>
          <MediaQuery maxWidth={991.7}>
          <Suspense fallback={<div />}>
            <LogoCarousel />
          </Suspense>
          </MediaQuery>
          <Suspense fallback={<div style={loadingStyle}></div>}>
            <RealStories data={data} />
          </Suspense>
          <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
            <WhyRefinance data={data} />
            <WhyChooseSunwest data={data} />
          </Suspense>
          <div className="celebrity-videos-section">
            <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
              <Celebrity data={data} />
            </Suspense>
          </div>
          <Suspense fallback={<div style={loadingStyle}>Loading...</div>}>
            <Blog data={data} />
          </Suspense>
          { loCommonData ? <Suspense fallback={<div/>}><LoTemplate loCommonData={loCommonData} /></Suspense> : ""}
          <Suspense fallback={<div />}>
            <Disclaimer fetchpriority="low" data={data} />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer fetchpriority="low" />
          </Suspense>
        </>
      )}
    </>
  );
}

